import { Node } from '@prisma/client';
import { Select, SelectProps } from 'antd';

import { useFindNodes } from '../../nodes';

export const NodePicker = ({ style, ...props }: Omit<SelectProps, 'loading' | 'options'>) => {
  const { data, isFetching, isPending } = useFindNodes<Node>({});

  return (
    <Select
      allowClear
      style={style ?? { width: '100%' }}
      loading={isPending || isFetching}
      options={data?.data.map((x) => ({ label: x.name, value: x.id }))}
      {...props}
    />
  );
};
